import React from "react";
import { Container, FixWidth, List, ListTitle, SmallText, DetailContainer, TextContainer, Label, Text, ButtonContainer, Button} from "./styles/cardList";

export default function CardLists({children, ...props}){
    return <Container {...props}>{children}</Container>
}

CardLists.FixWidth = function CardListsFixWidth({children, ...props}){
    return <FixWidth {...props}>{children}</FixWidth>
}

CardLists.List = function CardListsList({children, ...props}){
    return <List {...props}>{children}</List>
}

CardLists.ListTitle = function CardListsListTitle({children, ...props}){
    return <ListTitle {...props}>{children}</ListTitle>
}

CardLists.SmallText = function CardListsSmallText({children, ...props}){
    return <SmallText {...props}>{children}</SmallText>
}

CardLists.DetailContainer = function CardListsDetailContainer({children, ...props}){
    return <DetailContainer {...props}>{children}</DetailContainer>
}

CardLists.TextContainer = function CardListsTextContainer({children, ...props}){
    return <TextContainer {...props}>{children}</TextContainer>
}

CardLists.Label = function CardListsLabel({children, ...props}){
    return <Label {...props}>{children}</Label>
}

CardLists.Text = function CardListsText({children, ...props}){
    return <Text {...props}>{children}</Text>
}

CardLists.ButtonContainer = function CardListsButtonContainer({children, ...props}){
    return <ButtonContainer {...props}>{children}</ButtonContainer>
}

CardLists.Button = function CardListsButton({children, ...props}){
    return <Button {...props}>{children}</Button>
}




